// src/pages/Enseignants/Events/ExerciseInfoModal.jsx
import React, { useEffect } from "react";
import { FaTimes, FaExternalLinkAlt } from "react-icons/fa";
import Button from "../../../components/Button/Button";

const ExerciseInfoModal = ({ isOpen, onClose, exercise }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen || !exercise) return null;

  return (
    <div className="fixed inset-0 z-[120]">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />

      {/* Centered panel */}
      <div
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                   w-[min(900px,92vw)] max-h-[85vh]
                   bg-white dark:bg-slate-900 rounded-2xl shadow-2xl
                   ring-1 ring-slate-200/70 dark:ring-slate-700/70
                   overflow-hidden flex flex-col font-montserrat"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 px-5 py-4 flex items-center justify-between">
          <div className="min-w-0">
            <h3 className="text-white font-semibold truncate">
              {exercise.nom || "Détail de l’exercice"}
            </h3>
            {exercise.programme && (
              <div className="text-white/90 text-xs mt-1 truncate">
                {exercise.programme}
              </div>
            )}
          </div>
          <Button
            text="Fermer"
            icon={FaTimes}
            onClick={onClose}
            className="!rounded-xl bg-white/10 hover:bg-white/20 text-white gap-2"
          />
        </div>

        {/* Body (scrollable) */}
        <div className="p-5 sm:p-7 overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Illustration */}
            <div className="rounded-xl ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white dark:bg-slate-900 p-4">
              <div className="text-sm font-semibold mb-2 text-slate-800 dark:text-slate-100">
                Illustration
              </div>
              {exercise.lien_photo ? (
                <img
                  src={exercise.lien_photo}
                  alt={exercise.nom || "Illustration"}
                  className="w-full max-h-[320px] object-contain rounded-md"
                />
              ) : (
                <div className="text-sm opacity-70 text-slate-600 dark:text-slate-300">
                  Aucune image.
                </div>
              )}
            </div>

            {/* Vidéo */}
            <div className="rounded-xl ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white dark:bg-slate-900 p-4">
              <div className="text-sm font-semibold mb-2 text-slate-800 dark:text-slate-100">
                Vidéo
              </div>
              {exercise.lien_video ? (
                <a
                  href={exercise.lien_video}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-blue-600 dark:text-blue-400 underline"
                >
                  Ouvrir la vidéo <FaExternalLinkAlt />
                </a>
              ) : (
                <div className="text-sm opacity-70 text-slate-600 dark:text-slate-300">
                  Aucune vidéo.
                </div>
              )}
            </div>
          </div>

          {/* Description */}
          <div className="mt-5 rounded-xl ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white dark:bg-slate-900 p-4">
            <div className="text-sm font-semibold mb-2 text-slate-800 dark:text-slate-100">
              Description
            </div>
            {exercise.description ? (
              <div
                className="prose prose-sm dark:prose-invert max-w-none text-slate-800 dark:text-slate-200"
                dangerouslySetInnerHTML={{ __html: exercise.description }}
              />
            ) : (
              <div className="text-sm opacity-70 text-slate-600 dark:text-slate-300">
                Aucune description.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExerciseInfoModal;
